var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKettlebell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57545C"
    },
    d: "M330.75,0h-149.5C115.24,0,66.961,62.269,83.406,126.199l32.772,128.095l280.648-3.093 l31.768-125.002C445.039,62.269,396.76,0,330.75,0z M376.452,149.27l-14.863,57.782l-211.177,0.005l-14.865-57.787 c-11.477-44.615,22.216-88.074,68.285-88.074h104.335C354.236,61.196,387.929,104.654,376.452,149.27z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D20"
    },
    points: "370.94,170.552 361.551,207.052 150.374,207.057 140.984,170.552 94.715,170.552 116.14,254.294 396.788,251.201 417.285,170.552 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3E3B43"
    },
    cx: 255.273,
    cy: 341.201,
    r: 170.658
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D20"
    },
    d: "M255.27,486.375c-89.939,0-163.624-69.577-170.175-157.84c-0.314,4.23-0.477,8.502-0.477,12.813 C84.617,435.596,161.021,512,255.27,512s170.653-76.404,170.653-170.653c0-4.31-0.164-8.582-0.477-12.813 C418.892,416.799,345.207,486.375,255.27,486.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M315.338,405.219H195.2c-15.076,0-27.41-12.334-27.41-27.41v-79.9 c0-37.207,30.441-67.648,67.648-67.648H275.1c37.207,0,67.648,30.441,67.648,67.648v79.9 C342.748,392.884,330.414,405.219,315.338,405.219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505"
    },
    d: "M259.742,364.684c-4.319,0-7.818-3.501-7.818-7.818v-56.707l-14.252,14.252 c-3.054,3.053-8.004,3.053-11.057,0c-3.053-3.053-3.053-8.004,0-11.056l27.6-27.6c2.237-2.236,5.599-2.905,8.521-1.695 c2.922,1.21,4.827,4.061,4.827,7.223v75.581C267.56,361.184,264.061,364.684,259.742,364.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505"
    },
    d: "M278.864,364.684H240.62c-4.319,0-7.818-3.501-7.818-7.818s3.499-7.818,7.818-7.818h38.244 c4.319,0,7.818,3.501,7.818,7.818S283.183,364.684,278.864,364.684z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202.192,
    style: {
      fill: "#3E3B43"
    },
    width: 107.622,
    height: 61.271
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKettlebell);
export default __webpack_public_path__ + "static/media/kettlebell.74efbc193c3ba6c57fe3e705ff5d2ace.svg";
export { ForwardRef as ReactComponent };